import PropTypes from 'prop-types';

import './progressIndicator.scss';

export default function ProgressIndicator({ items=[] }) {

  const total = items?.reduce((acc, item) => acc + item.value, 0);
  return (
    <div className="progress-indicator">
      <div className="progress-indicator-bar">
        {items?.filter(item => item.value)?.map((item, index) => (
          <div
            key={index}
            className="progress-indicator-item"
            style={{
              width: `${(item.value / total) * 100}%`,
              height: '100%',
              backgroundColor: item.color,
            }}
          />
        )) }
      </div>
      <div className="progress-indicator-legend">
        {items?.map((item, index) => (
          <div key={index} className="legend-item">
            <div
              style={{
                borderRadius: '50%',
                height: '20px',
                width: '20px',
                backgroundColor: item.color,
              }}
            />
            <span>{item.name}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

ProgressIndicator.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
}
